import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {Navigate} from 'react-router-dom';
import {logout} from "../features/auth/authSlice";

const Logout = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        localStorage.clear();
        sessionStorage.clear();
        dispatch(logout());
    }, [dispatch]);

    return <Navigate to="/login" replace/>;
};

export default Logout;
